(function () {
    var sidebarSections = {
        isMobile: parseInt(UX.grid.screenSm) >= window.innerWidth,
        $scrollPoints: $('.to-section[id]:visible'),
        $block: $('.sections-block'),
        vPort: 'screen-sm',

        init: function () {
            if (sidebarSections.$scrollPoints.length || UX.sidebarSections.$block.children().length) {
                sidebarSections.initSections();
                sidebarSections.set.selectedSection();
                sidebarSections.controller();
                if (!sidebarSections.isMobile) {
                    sidebarSections.sectionTitleClick();
                }
            } else {
                //if there is no section then hide action bar on tablet
                // hiding with visibility and height to keep the layout in order
                if ($('.sections-navigation').find('.article-tabs-block-container').length === 0) {
                    $('.sections-navigation').hide();
                }
            }
        },

        initSections: function () {
            //if theres is sections then show section word & initialize it
            $('.sections-block-container').removeClass('not-visible');
            $('.article-navigation-items-separator').removeClass('not-visible');

            $(sidebarSections.$scrollPoints.get().reverse()).each(function () {
                sidebarSections.$block.prepend(sidebarSections.get.htmlSection($(this)));
            });

            $('.actionsbar__has__sections .sections-block-container').css({
                'max-height': 'calc(100vh - " +$("header").height()+ "px)',
            });
        },

        controller: function () {
            $(document).on('click', '.sections-block a', function (e) {
                const _this = $(this);
                if (_this.parents().hasClass('sections-block__external-link')) return;
                e.preventDefault();
                UX.sidebarSections.scroll(_this, this.hash);
                let $elemParent = _this.parents('.js--open');
                if ($elemParent.length > 0) {
                    $elemParent.prev('[data-db-target-for]').click();
                    $elemParent.find('.w-slide__back').click();
                }
            });
            const _window = $(window);
            const $sectionsNav = $('.sections-navigation');
            const $footer = $('footer');

            _window.on('scroll', function () {
                const footerTop = $footer.offset().top;
                const scrollTop = $(window).scrollTop() + $(window).height();
                const headerHeight = $('header').height();
                if (scrollTop >= footerTop) {
                    $sectionsNav.css('max-height', `calc(100vh - ${headerHeight + scrollTop - footerTop}px)`);
                } else {
                    $sectionsNav.css('max-height', '');
                }

                const scrollingPoints = UX.sidebarSections.$scrollPoints,
                    fixedElems = sidebarSections.get.fixedpageElementsHeight(),
                    bottom = _window.scrollTop() + _window.height() / 2,
                    top = _window.scrollTop() + fixedElems / 2;
                /*
                 Divisions by 2 above are to improve UX by making switches
                 close to page center and therefore making them more relevant for a user
                 */

                const inSights = scrollingPoints.filter(function (index, elem) {
                    return $(elem).offset().top > top && $(elem).offset().top < bottom;
                });

                let currentId;
                if (inSights.length) {
                    currentId = inSights.eq(0).attr('id');
                } else {
                    // taking the previous title in case we are scrolling but there is nothing what is valid to be marked as current
                    let preceding;
                    scrollingPoints.each(function (i, o) {
                        // picking the last closest preceding element
                        const item = $(o);
                        if (item.offset().top < top && (!preceding || preceding.offset().top < item.offset().top)) {
                            preceding = item;
                        }
                    });
                    if (preceding) {
                        currentId = preceding.attr('id');
                    }
                }

                if (currentId) {
                    UX.sidebarSections.$block
                        .find('a')
                        .removeClass('active')
                        .filter('[href="#' + currentId + '"]')
                        .addClass('active');
                    if (
                        window.pageYOffset + window.innerHeight + 100 >= document.body.scrollHeight &&
                        !sidebarSections.isMobile
                    ) {
                        // + 100 to ensure that the scroll arrive the end
                        if (UX.sidebarSections.$block.find('li').last().hasClass('sections-block__external-link'))
                            return;
                        UX.sidebarSections.$block.find('a').removeClass('active').last().addClass('active');
                    }
                } else {
                    UX.sidebarSections.$block.find('a').removeClass('active');
                }
            });
        },

        scroll: function ($this, hash) {
            const target = hash,
                $target = $(target),
                position = $target.offset().top - sidebarSections.get.fixedpageElementsHeight();
            $('html, body').stop().animate(
                {
                    scrollTop: position,
                },
                300
            );
        },

        set: {
            selectedSection: function () {
                if (window.location.hash) {
                    sidebarSections.$block.find('a[href="' + window.location.hash + '"]').addClass('active');
                }
            },
        },

        get: {
            scrollingSectionPoints: function () {
                return sidebarSections.$scrollPoints;
            },

            htmlSection: function ($this) {
                let subMenu = '';
                if ($this.is('h5')) {
                    subMenu = ' - ';
                }
                return (
                    '<li><a title="' +
                    $this.text() +
                    '" href="#' +
                    $this.attr('id') +
                    '">' +
                    subMenu +
                    $this.text() +
                    '</a></li>'
                );
            },

            fixedpageElementsHeight: function () {
                let elementsHeight =
                    $('header').css('position') === 'fixed' || $('header').css('position') === 'sticky'
                        ? $('header').outerHeight()
                        : 0;
                $('.actionsbar').each(function () {
                    if ($(this).outerHeight() > 0) {
                        elementsHeight += $(this).outerHeight();
                    }
                });
                return elementsHeight;
            },
        },

        sectionTitleClick: () => {
            let actionBarLinks = document.querySelectorAll('.actionsbar a');
            if (actionBarLinks !== null) {
                [...actionBarLinks].forEach(link => {
                    link.addEventListener('click', function () {
                        setTimeout(() => {
                            if (!this.classList.contains('active')) {
                                let activeLink = document.querySelector('.actionsbar a.active');
                                if (activeLink !== null) {
                                    activeLink.classList.remove('active');
                                    this.classList.add('active');
                                }
                            }
                        }, 10);
                    });
                });
            }
        },
    };

    UX.sidebarSections = sidebarSections; // add to global namespace
})();
